import { CMS_COMMON_API, REDIRECT_URI, CATEGORY_MENU_DATA_URL } from 'aster-foundation/core/common/utils/ApiConst';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';
import ListOfData from '../../../public/asterWebLandingPage.json';
import CommonHomePage from '@common/Component/CommonHomePage/CommonHomePage';
import CommonMeta from '@common/Component/CommonMeta/CommonMeta';
import { sendPageviewEvent } from '@common/Utility/analytics-utils';
import { getReferralPageForGA } from '@common/Utility/common-utils';
import {
  DYNAMIC_DASHBOARD_PARAMETER,
  HOME_PAGE_JSON_FILE_NAME,
  ONE_ASTER_CATEGORY,
  staticAscoJson as staticJSON,
} from '@common/Utility/constants';
import { PAGE_NAME } from '@common/Constants/analytics';
import { useSetCommonParams } from '@common/Utility/analytics-common';

async function fetchJson(url, defaultValue) {
  try {
    const response = await fetch(url);
    return await response.json();
  } catch (e) {
    console.error(`Error fetching JSON from ${url}: ${e}`);
    return defaultValue;
  }
}

async function getCMSCommonResult() {
  const url = `${CMS_COMMON_API}${DYNAMIC_DASHBOARD_PARAMETER.CORE}?channel=Web`;
  const response = await fetch(url);
  const data = await response.json();
  return data.data || '';
}

export async function getServerSideProps(context) {
  let [staticJsonResponse, cmsCommonResult] = [];
  try {
    [staticJsonResponse, cmsCommonResult] = await Promise.all([fetchJson(staticJSON, null), getCMSCommonResult()]);
  } catch {
    [staticJsonResponse] = await Promise.all([fetchJson(staticJSON, null)]);
  }

  const refPageString = context?.req?.headers?.referer?.split('/');
  const referrerPage = getReferralPageForGA(refPageString);

  const userAgent = context?.req?.headers['user-agent'];
  const isMobile = Boolean(userAgent?.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i));

  let fileURL = `${CATEGORY_MENU_DATA_URL}/static/static_pages/`;

  if (isMobile) {
    fileURL += HOME_PAGE_JSON_FILE_NAME.MOBILE;
  } else {
    fileURL += HOME_PAGE_JSON_FILE_NAME.WEB;
  }

  const result = await fetchJson(fileURL, ListOfData);

  const ascoTemplate = cmsCommonResult?.template || staticJsonResponse;
  const bannerTopItem = ascoTemplate?.find((item) => item?.component_type === 'Hero Banner')?.banners || [];

  return {
    props: {
      ascoTemplate,
      bannerTopItem,
      referrerPage,
      result,
      query: context?.query,
      jsonFile: staticJsonResponse,
    },
  };
}

function updateSeoData(seoData, bannerTopItem) {
  return seoData?.meta?.map((metaItem) =>
    metaItem?.name === 'og:image' ? { ...metaItem, value: bannerTopItem?.[0]?.imageWeb } : metaItem,
  );
}

function Home(props) {
  const [seoData, setSeoData] = useState(props?.result?.homeSeo ?? ListOfData.homeSeo);
  const router = useRouter();
  useSetCommonParams({ screen: PAGE_NAME.HOME, page: PAGE_NAME.ASCO, category: ONE_ASTER_CATEGORY.CORE });

  useEffect(() => {
    const { query, bannerTopItem } = props;

    if (query?.asPath) {
      router.push(REDIRECT_URI + decodeURIComponent(query.asPath));
    } else if (seoData && bannerTopItem) {
      const newSeoMetaData = updateSeoData(seoData, bannerTopItem);
      setSeoData({ ...seoData, meta: newSeoMetaData });
    }
    sendPageviewEvent(PAGE_NAME.HOME, ONE_ASTER_CATEGORY.CORE, PAGE_NAME.ASCO);
  }, []);

  return (
    <>
      <CommonMeta metaData={seoData} />
      <h1 className="d-none">myAster</h1>
      <CommonHomePage cmsAscoResult={props?.ascoTemplate} referrerPage={props?.referrerPage} screenName = {PAGE_NAME.HOME} myaster_category = {ONE_ASTER_CATEGORY.CORE} page_type = {PAGE_NAME.ASCO} />
    </>
  );
}

Home.propTypes = {
  result: PropTypes.object,
  bannerTopItem: PropTypes.array,
  referrerPage: PropTypes.string,
  query: PropTypes.string,
  ascoTemplate: PropTypes.object,
};

Home.defaultProps = {
  result: {},
  bannerTopItem: [],
  referrerPage: '',
  query: '',
  ascoTemplate: {},
};

export default memo(Home);
